import React, { Component } from 'react'

import './tabItem.scss'

class TabItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
    this.onClick = this.onClick.bind(this)
  }

  onClick (e) {
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return 'size-large'
      case 'm':
        return 'size-medium'
      case 's':
        return 'size-small'
    }
  }

  getActiveClass () {
    return this.props.active ? ' active' : ''
  }

  getStyle () {
    return 'element-tab-item ' + this.getSizeClass()
  }

  render () {
    return (
      <li className={this.getStyle()}>
        {this.props.children !== undefined && this.props.children !== null && this.props.children}
        {(this.props.children === undefined || this.props.children === null) && (
          <div className={'tab-item' + this.getActiveClass()} onClick={this.onClick}>
            {this.props.labelText}
          </div>
        )}
      </li>
    )
  }
}

TabItem.defaultProps = {
  size: 'l',
  labelText: null,
  value: null,
  name: null,
  onClick: null,
  active: false
}

export default TabItem



// WEBPACK FOOTER //
// ./src/app/shared/elements/tabItem/index.js